module.exports = __webpack_public_path__ + "img/logo.46f2c510.png";